import { PROJECTS_CONFIG } from "../config/projectsConfig";
import { getMergedProjectsConfig } from "../config/projectsService";
import {
    getScrexPreSaleContract,
    getKaiPreSaleContract,
    getRainPreSaleContract,
    getRainPreSaleV2Contract,
    getRainPreSaleV3Contract,
    getAstroNovaPreSaleContract,
    getAstroNovaPreSaleV2Contract,
    getMinersClaimsContract,
    // Claim contract imports
    getScrexClaimsContract,
    getKaiClaimsContract,
    getMatchainClaimsContract,
    getLuckifyClaimsContract,
    getIncentivClaimsContract,
    getNFAClaimsContract,
    getAstroNovaClaimsContract,
    getAstroNovaClaimsV2Contract,
    getRainClaimsContract,
    getRainClaimsV2Contract,
    getRainClaimsV3Contract,
    getLEIAClaimsContract,
    getOlympusClaimsContract,
    getGemsClaimsContract,
    getMinersClaimsOldContract,
    getMinersClaimsV2Contract,
    getClaimNewLatest,
} from "../utils/contractHelpers";
import Environment from "../utils/Environment";

/**
 * AUTO-GENERATED CONTRACT CONFIGURATION
 * This file is automatically populated from projectsConfig.js
 * DO NOT manually add projects here - update projectsConfig.js instead
 */

// Contract helper mapping
const CONTRACT_HELPERS = {
    screx: {
        preSale: getScrexPreSaleContract,
        claim: getScrexClaimsContract,
    },
    kai: {
        preSale: getKaiPreSaleContract,
        claim: getKaiClaimsContract,
    },
    rain: {
        preSale: getRainPreSaleContract,
        claim: getRainClaimsContract,
    },
    rainV2: {
        preSale: getRainPreSaleV2Contract,
        claim: getRainClaimsV2Contract,
    },
    rainV3: {
        preSale: getRainPreSaleV3Contract,
        claim: getRainClaimsV3Contract,
    },
    astroNova: {
        preSale: getAstroNovaPreSaleContract,
        claim: getAstroNovaClaimsContract,
    },
    astroNovaV2: {
        preSale: getAstroNovaPreSaleV2Contract,
        claim: getAstroNovaClaimsV2Contract,
    },
    miners: {
        preSale: getMinersClaimsContract,
        claim: getMinersClaimsContract,
    },
    matchain: {
        claim: getMatchainClaimsContract,
    },
    luckify: {
        claim: getLuckifyClaimsContract,
    },
    incentiv: {
        claim: getIncentivClaimsContract,
    },
    nfa: {
        claim: getNFAClaimsContract,
    },
    leia: {
        claim: getLEIAClaimsContract,
    },
    olympus: {
        claim: getOlympusClaimsContract,
    },
    gems: {
        claim: getGemsClaimsContract,
    },
    minersOld: {
        claim: getMinersClaimsOldContract,
    },
    minersV2: {
        claim: getMinersClaimsV2Contract,
    },
    dopLatest: {
        claim: getClaimNewLatest,
    },
};

// Generate contract configuration for a project
const generateProjectConfig = (project) => {
    const config = {
        id: project.id,
        contracts: {},
        graph: {
            url: project.graph.url,
            queryType: project.graph.queryType,
        },
        ...project,
    };

    // Get contract helpers
    const contractType = project.contractType || "screx";
    const claimContractType = project.claimContractType || project.contractType || "screx";

    // Add main contracts
    if (project.contracts.preSale) {
        config.contracts.preSale = {
            address: project.contracts.preSale,
            contract: CONTRACT_HELPERS[contractType]?.preSale || getScrexPreSaleContract,
        };
    }

    if (project.contracts.claim) {
        config.contracts.claim = {
            address: project.contracts.claim,
            contract: CONTRACT_HELPERS[claimContractType]?.claim || getScrexClaimsContract,
        };
    }

    // Add versioned contracts
    if (project.contracts.versions) {
        Object.entries(project.contracts.versions).forEach(([version, contracts]) => {
            const versionKey = version.toLowerCase();
            const versionType = `${project.contractType}${version.toUpperCase()}`;

            if (contracts.preSale) {
                config.contracts[versionKey] = {
                    address: contracts.preSale,
                    contract: CONTRACT_HELPERS[versionType]?.preSale || CONTRACT_HELPERS[contractType]?.preSale,
                };
            }

            if (contracts.claim) {
                const claimKey = `claim${version.toUpperCase()}`;
                config.contracts[claimKey] = {
                    address: contracts.claim,
                    contract: CONTRACT_HELPERS[versionType]?.claim || CONTRACT_HELPERS[claimContractType]?.claim,
                };
            }
        });
    }

    // Add graph versions
    if (project.graph.versions) {
        config.graph.versions = project.graph.versions;
    }

    // Add special graph properties for DOP
    if (project.graph.oldGraphUrl) {
        config.graph.oldGraphUrl = project.graph.oldGraphUrl;
    }
    if (project.graph.oldGraphThreshold) {
        config.graph.oldGraphThreshold = project.graph.oldGraphThreshold;
    }

    // Add custom methods for special projects
    if (project.customMethods) {
        config.customMethods = project.customMethods;
    }

    return config;
};
const projects = await getMergedProjectsConfig(PROJECTS_CONFIG);

// Auto-generate the projectContractsConfig array
export const projectContractsConfig = projects?.map(generateProjectConfig);
// import {
//     getScrexPreSaleContract,
//     getRainPreSaleContract,
//     getRainPreSaleV2Contract,
//     getRainPreSaleV3Contract,
//     getAstroNovaPreSaleContract,
//     getAstroNovaPreSaleV2Contract,
//     getMinersClaimsContract,
//     // Claim contract imports
//     getScrexClaimsContract,
//     getMatchainClaimsContract,
//     getLuckifyClaimsContract,
//     getIncentivClaimsContract,
//     getNFAClaimsContract,
//     getAstroNovaClaimsContract,
//     getAstroNovaClaimsV2Contract,
//     getRainClaimsContract,
//     getRainClaimsV2Contract,
//     getRainClaimsV3Contract,
//     getLEIAClaimsContract,
//     getOlympusClaimsContract,
//     getGemsClaimsContract,
//     getMinersClaimsOldContract,
//     getMinersClaimsV2Contract,
//     getClaimNewLatest,
// } from "../utils/contractHelpers";
// import Environment from "../utils/Environment";

// export const projectContractsConfig = [
//     {
//         id: "XPROTOCOL",
//         contracts: {
//             preSale: {
//                 address: Environment.XPROTOCOLPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.XPROTOCOLClaim,
//                 contract: getScrexClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.XPROTOCOLGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "TIGA",
//         contracts: {
//             preSale: {
//                 address: Environment.TIGAPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.TIGAClaim,
//                 contract: getScrexClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.TIGAGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "CHAINERS",
//         contracts: {
//             preSale: {
//                 address: Environment.CHAINERSPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.CHAINERSClaim,
//                 contract: getScrexClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.CHAINERSGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "SCREX",
//         contracts: {
//             preSale: {
//                 address: Environment.SCREXPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.SCREXClaim,
//                 contract: getScrexClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.SCREXGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "LUCKIFY",
//         contracts: {
//             preSale: {
//                 address: Environment.LUCKIFYPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.LUCKIFYClaim,
//                 contract: getLuckifyClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.LUCKIFYGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "MATCHAIN",
//         contracts: {
//             preSale: {
//                 address: Environment.MATCHAINPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.MATCHAINClaim,
//                 contract: getMatchainClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.MATCHAINGraph,
//             queryType: "matchain",
//         },
//     },
//     {
//         id: "RAIN",
//         contracts: {
//             preSale: {
//                 address: Environment.RainPreSaleV3,
//                 contract: getRainPreSaleV3Contract,
//             },
//             claim: {
//                 address: Environment.RainClaimV3,
//                 contract: getRainClaimsV3Contract,
//             },
//             v1: {
//                 address: Environment.RainPreSale,
//                 contract: getRainPreSaleContract,
//             },
//             claimV1: {
//                 address: Environment.RainClaim,
//                 contract: getRainClaimsContract,
//             },
//             v2: {
//                 address: Environment.RainPreSaleV2,
//                 contract: getRainPreSaleV2Contract,
//             },
//             claimV2: {
//                 address: Environment.RainClaimV2,
//                 contract: getRainClaimsV2Contract,
//             },
//             v3: {
//                 address: Environment.RainPreSaleV3,
//                 contract: getRainPreSaleV3Contract,
//             },
//             claimV3: {
//                 address: Environment.RainClaimV3,
//                 contract: getRainClaimsV3Contract,
//             },
//         },
//         graph: {
//             url: Environment.RainGraphV3,
//             queryType: "standard",
//             versions: {
//                 v1: Environment.RainGraph,
//                 v2: Environment.RainGraphV2,
//                 v3: Environment.RainGraphV3,
//             },
//         },
//     },
//     {
//         id: "ASTRANOVA",
//         contracts: {
//             preSale: {
//                 address: Environment.AstroNovaPreSaleV2,
//                 contract: getAstroNovaPreSaleV2Contract,
//             },
//             claim: {
//                 address: Environment.AstroNovaClaimV2,
//                 contract: getAstroNovaClaimsV2Contract,
//             },
//             v1: {
//                 address: Environment.AstroNovaPreSale,
//                 contract: getAstroNovaPreSaleContract,
//             },
//             claimV1: {
//                 address: Environment.AstroNovaClaim,
//                 contract: getAstroNovaClaimsContract,
//             },
//             v2: {
//                 address: Environment.AstroNovaPreSaleV2,
//                 contract: getAstroNovaPreSaleV2Contract,
//             },
//             claimV2: {
//                 address: Environment.AstroNovaClaimV2,
//                 contract: getAstroNovaClaimsV2Contract,
//             },
//         },
//         graph: {
//             url: Environment.AstroNovaGraphV2,
//             queryType: "standard",
//             versions: {
//                 v1: Environment.AstroNovaGraph,
//                 v2: Environment.AstroNovaGraphV2,
//             },
//         },
//     },
//     {
//         id: "NFA",
//         contracts: {
//             preSale: {
//                 address: Environment.NFAPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.NFAClaim,
//                 contract: getNFAClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.NFAGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "LEIA",
//         contracts: {
//             preSale: {
//                 address: Environment.LEIAPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.LEIAClaim,
//                 contract: getLEIAClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.LEIAGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "OLYMPUS",
//         contracts: {
//             preSale: {
//                 address: Environment.OlympusPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.OlympusClaim,
//                 contract: getOlympusClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.OlympusGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "INCENTIV",
//         contracts: {
//             preSale: {
//                 address: Environment.IncentivPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.IncentivClaim,
//                 contract: getIncentivClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.IncentivGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "GEMS",
//         contracts: {
//             preSale: {
//                 address: Environment.GEMSPreSale,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.GEMSClaim,
//                 contract: getGemsClaimsContract,
//             },
//         },
//         graph: {
//             url: Environment.GEMSGraph,
//             queryType: "standard",
//         },
//     },
//     {
//         id: "NODEMINER",
//         contracts: {
//             preSale: {
//                 address: Environment.MinersClaim,
//                 contract: getMinersClaimsContract,
//             },
//             claim: {
//                 address: Environment.MinersClaim,
//                 contract: getMinersClaimsContract,
//             },
//             claimV1: {
//                 address: Environment.MinersClaimOld,
//                 contract: getMinersClaimsOldContract,
//             },
//             claimV2: {
//                 address: Environment.MinersClaim,
//                 contract: getMinersClaimsContract,
//             },
//             claimV3: {
//                 address: Environment.MinersClaimV2,
//                 contract: getMinersClaimsV2Contract,
//             },
//         },
//         customMethods: {
//             getRoundCount: "currentWeek",
//             claimMethod: {
//                 v1: "claim",
//                 v2: "claimAll",
//                 v3: "claimAll",
//             },
//         },
//         graph: {
//             url: Environment.MinersGraphV2,
//             queryType: "miners",
//             versions: {
//                 v1: Environment.MinersGraphOld,
//                 v2: Environment.MinersGraph,
//                 v3: Environment.MinersGraphV2,
//             },
//         },
//     },
//     {
//         id: "DOP",
//         contracts: {
//             preSale: {
//                 address: Environment.DOPRoundSingleContract,
//                 contract: getScrexPreSaleContract,
//             },
//             claim: {
//                 address: Environment.claimNewLatest,
//                 contract: getClaimNewLatest,
//             },
//         },
//         graph: {
//             url: Environment.graph,
//             queryType: "dop",
//             oldGraphUrl: Environment.oldGraph,
//             oldGraphThreshold: 7,
//         },
//     },
// ];